export default __webpack_public_path__ + "static/media/User_Manual_DDO_Mandal_Mapping.2e6ed230.pdf";